export default "__VITE_ASSET__D3BHX5uA__"